import "./scripts/main.ts"
import "./styles/main.scss"
